// UI labels and navigation translations for O-Ton

import type { Locale, Localized } from "@/types/content";

/**
 * Core identity phrase used in hero and footer
 */
export const IDENTITY_PHRASE: Localized<string> = {
  de: "Konzerte // Recording // Proben // Projekte",
  en: "Concerts // Recording // Rehearsals // Projects",
  fr: "Concerts // Enregistrement // Répétitions // Projets",
  es: "Conciertos // Grabación // Ensayos // Proyectos",
};

/**
 * Main navigation labels
 */
export const NAV_LABELS = {
  home: {
    de: "o-ton",
    en: "o-ton",
    fr: "o-ton",
    es: "o-ton",
  },
  studioHall: {
    de: "o-ton Studio-Saal",
    en: "o-ton Studio Hall",
    fr: "Salle-Studio o-ton",
    es: "Sala-Estudio o-ton",
  },
  events: {
    de: "Konzerte/Veranstaltungen",
    en: "Concerts/Events",
    fr: "Concerts/Événements",
    es: "Conciertos/Eventos",
  },
  blog: {
    de: "Blog/Journal",
    en: "Blog/Journal",
    fr: "Blog/Journal",
    es: "Blog/Journal",
  },
  references: {
    de: "Audio/Videos / Referenzen",
    en: "Audio/Videos / References",
    fr: "Audio/Vidéos / Références",
    es: "Audio/Vídeos / Referencias",
  },
  artistGallery: {
    de: "o-ton Artist & Guest Galerie",
    en: "o-ton Artist & Guest Gallery",
    fr: "Galerie Artist & Guest o-ton",
    es: "Galería Artist & Guest o-ton",
  },
  about: {
    de: "About",
    en: "About",
    fr: "À propos",
    es: "Acerca de",
  },
  contact: {
    de: "Contact",
    en: "Contact",
    fr: "Contact",
    es: "Contacto",
  },
} as const;

/**
 * Four main content panel titles (home page)
 */
export const PANEL_TITLES = {
  studioHall: {
    de: "o-ton Studio-Saal",
    en: "o-ton Studio Hall",
    fr: "Salle-Studio o-ton",
    es: "Sala-Estudio o-ton",
  },
  concerts: {
    de: "Konzerte/Veranstaltungen",
    en: "Concerts/Events",
    fr: "Concerts/Événements",
    es: "Conciertos/Eventos",
  },
  blog: {
    de: "Blog/Journal",
    en: "Blog/Journal",
    fr: "Blog/Journal",
    es: "Blog/Journal",
  },
  artistGuest: {
    de: "o-ton Artist & Guest (Referenzen)",
    en: "o-ton Artist & Guest (References)",
    fr: "o-ton Artist & Guest (Références)",
    es: "o-ton Artist & Guest (Referencias)",
  },
} as const;

/**
 * Helper to get a localized label
 */
export function getLabel<T extends Record<string, Localized<string>>>(
  labels: T,
  key: keyof T,
  locale: Locale = "de"
): string {
  const label = labels[key];
  if (!label) return "";
  return label[locale] || label.de || "";
}
